require('./mortgageRequestDuesPayments.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @helpers
const dateHelper = require('utilities/dateHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { EmptyState } = require('commonsComponents/emptyState');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @constants
const { getUnpaidFees } = require('constants/loans');


class MortgageRequestDuesPayments extends React.Component {
    constructor(props) {
        super(props);
        this.tableTitle = formatText('mortgageRequestDuesPayments-tableTitle');
    }

    buildTable() {
        const tableBody = this.buildTableBody();

        return (
            <OKTable id="mortgage-dues-payments-table" className="mortgage-request-dues-payments__table">
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="mortgageRequestDuesPayments-tableHeaderOperationDate" format="firstUppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="mortgageRequestDuesPayments-tableHeaderValidDate" format="firstUppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="mortgageRequestDuesPayments-tableHeaderConcept" format="firstUppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="mortgageRequestDuesPayments-tableHeaderSituation" format="firstUppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="mortgageRequestDuesPayments-tableHeaderAmount" format="firstUppercase" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {tableBody}
                </tbody>
            </OKTable>
        );
    }

    buildTableBody() {
        const detalleCobro = this.props.paymentsList;

        return detalleCobro.map((item, index) => {
            const amountObject = {
                amount: item.importeAplicado.importe,
                currency: item.importeAplicado.divisa
            };
            const getOperationDate = dateHelper.formatDate(item.fechaOperacion);
            const operationDate = getOperationDate !== 'Invalid Date' && getOperationDate;
            const getValidityDate = dateHelper.formatDate(item.fechaValidez);
            const validityDate = getValidityDate !== 'Invalid Date' && getValidityDate;
            const plainAmountObject = getPlainAmountObject(amountObject);

            return (
                <OKTableRow key={index} id={`mortgage-dues-payments-table-row-${index}`}>
                    <OKTableCell className="mortgage-request-dues-payments__table-row-operationDate">
                        {operationDate}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-dues-payments__table-row-validDate">
                        {validityDate}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-dues-payments__table-row-concept">
                        {toFirstUppercase(item.nombreConcepto)}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-dues-payments__table-row-situation">
                        {getUnpaidFees().SITUATION_TYPES[item.indSituacion]}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-dues-payments__table-row-amount">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                </OKTableRow>
            )
        });
    }

    render() {
        let content;

        if (this.props.paymentsList.length > 0) {
            content = this.buildTable();
        } else {
            content = <EmptyState primaryText={formatText('mortgageRequestDuesPayments-noPayments')} iconType="noitems-banking"/>
        }

        return (
            <OKSectionBox>
                <OKBoxTitle value={this.tableTitle} />
                {content}
            </OKSectionBox>
        );
    }
}

MortgageRequestDuesPayments.propTypes = {
    paymentsList: PropTypes.array
};

module.exports = MortgageRequestDuesPayments;